import request from "@/utils/request";
import qs from "qs";
// 获取产品资料
export function getXcArticleAll(query) {
  return request({
    url: "cus/xcArticleAll/" + "?" + qs.stringify(query, { indices: false }),
    method: "Get",
  });
}




// WEBPACK FOOTER //
// ./src/api/productInformation.js